import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    title: 'Chargement ...',
    subtitle: '',
    version: '',
    payload: {}
  },
  mutations: {
    changeTitle (state, name) {
      state.title = name
    },
    changeSubtitle (state, name) {
      state.subtitle = name
    },
    setVersion (state, version) {
      state.version = version
    },
    setPayload (state, {name, value}) {
      Vue.set(state.payload, name, value)
    }
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/store/modules/app/ui.js